import { useState, useContext, useEffect, useRef } from "react"
import { BtnLoader, CSelect, toast, CInputText } from "../../../components/widget"
import { ContextNav, ContextDashboard, ContextLoading } from "../../../context";
import { DatePicker } from "jalali-react-datepicker";
import { EditSchedulesApi, JobsGroupApi, SingleSchedulesApi } from "../../../api";
import { useNavigate, useParams, Link } from "react-router-dom";

export const SchedulesEdit = () => {
    const navigate = useNavigate()
    let params = useParams();
    const formRef: any = useRef()
    const startDateRef: any = useRef()
    const endDateRef: any = useRef()
    const CtxNav = useContext(ContextNav)
    const CtxDash = useContext(ContextDashboard)
    const CtxLoad = useContext(ContextLoading)
    const [listGroup, setListGroup] = useState<any>([])
    const [floatingTime, setFloatingTime] = useState<boolean>(false)
    const [singleData, setSingleData] = useState<any>()
    const [flexible, setFlexible] = useState<number>(-1)


    const onFinishAdd = async (e: any) => {
        e.preventDefault()
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await EditSchedulesApi(formRef, singleData)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast("با موفقیت ویرایش گردید", { type: "success" })
            navigate('/p/settings/schedules');
        }
        else {
            toast(res.message, { type: "error" })
        }
    }

    const getListGroup = async () => {
        let res = await JobsGroupApi()
        if (res.success) {
            setListGroup(res.data)
        }
    }

    const getData = async () => {
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await SingleSchedulesApi(params.id)
        if (res.success) {
            setSingleData(res.data)
            formRef.current['description'].value = res.data.description;
            formRef.current['job-group'].value = res.data.job_group.id;
            if (res.data?.flexible == 1) {
                formRef.current['duration'].value = res.data?.duration;                
            }
            else {
                formRef.current['allowed_lateness_on_arrival'].value = res.data.allowed_lateness_on_arrival;
                formRef.current['allowed_lateness_on_exit'].value = res.data.allowed_lateness_on_exit;
                formRef.current['allowed_rushing_on_arrival'].value = res.data.allowed_rushing_on_arrival;
                formRef.current['allowed_rushing_on_exit'].value = res.data.allowed_rushing_on_exit;
                formRef.current['start_hours'].value = res.data.start_datetime?.slice(11, 13);
                formRef.current['start_min'].value = res.data.start_datetime?.slice(14, 16);
                formRef.current['end_hours'].value = res.data.end_datetime?.slice(11, 13);
                formRef.current['end_min'].value = res.data.end_datetime?.slice(14, 16);
            }
            if (Array.isArray(res.data.repeat)) {
                formRef.current['sat'].checked = true;
                formRef.current['sun'].checked = true;
                formRef.current['mon'].checked = true;
                formRef.current['tue'].checked = true;
                formRef.current['wed'].checked = true;
                formRef.current['thu'].checked = true;
                formRef.current['fri'].checked = true;
            }
            else {
                if (res.data.repeat['0']) { formRef.current['sun'].checked = true }
                if (res.data.repeat['1']) { formRef.current['mon'].checked = true }
                if (res.data.repeat['2']) { formRef.current['tue'].checked = true }
                if (res.data.repeat['3']) { formRef.current['wed'].checked = true }
                if (res.data.repeat['4']) { formRef.current['thu'].checked = true }
                if (res.data.repeat['5']) { formRef.current['fri'].checked = true }
                if (res.data.repeat['6']) { formRef.current['sat'].checked = true }
            }
            setFlexible(+res.data?.flexible)
            CtxLoad.setDisplayLoadingBlur(false)
        }
        else {
            CtxLoad.setDisplayLoadingBlur(false)
        }
    }

    useEffect(() => {
        document.title = "ویرایش شیفت کاری | دایان"
        CtxNav.setActiveMenuItem({ 'item': 3, 'subItem': 3, })
        getListGroup()
        getData()

    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">ویرایش شیفت کاری</h1>

            <form ref={formRef} onSubmit={onFinishAdd} className=" w-full  flex flex-col shadow sm:rounded-xl rounded-lg bg-white py-[15px] sm:py-[30px] sm:px-[20px] px-[10px]">

                <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full md:w-2/12 h-[50px] flex items-center md:mb-0 mb-1">
                        <svg x="0px" y="0px" viewBox={'0 0 460 460'} className={`  h-5 'fill-dayan-gray-100' `}>
                            <use xlinkHref="/assetes/svg/report.svg#report" />
                        </svg>
                        <span className="text-[11px] mr-3">مشخصات شیفت کاری </span>
                    </div>
                    <div className=" w-full md:w-10/12  flex items-center">
                        <div className=" w-[50%] h-[50px] pl-1 sm:pl-2">
                            <CInputText name="description" title="نام شیفت کاری" type="text" required={true} />
                        </div>
                        <div className=" w-[50%] h-[50px] pr1 sm:pr-2">
                            <CSelect name="job-group" placeholder={'انتخاب'} title="گروه شغلی" border={true} required={true} deisable={true}>
                                {listGroup?.map((item: any, index: number) =>
                                    <option key={index} value={item.id}>{item.name}</option>
                                )}
                            </CSelect>
                        </div>
                    </div>
                </div>

                {(flexible == -1 || flexible == 1) &&
                    <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                        <div className=" w-full md:w-2/12 h-[50px] flex items-center md:mb-0 mb-1">
                            <svg x="0px" y="0px" viewBox={'0 0 470 470'} className={`  h-5 'fill-dayan-gray-100' `}>
                                <use xlinkHref="/assetes/svg/clock2.svg#clock2" />
                            </svg>
                            <span className="text-[11px] mr-3"> ساعت کاری شناور </span>
                        </div>
                        <div className=" w-full md:w-10/12  flex sm:flex-nowrap flex-wrap items-center">
                            <label className=" w-full sm:w-[50%] h-[50px] pl-1 sm:pl-2 flex items-start sm:items-center justify-center  cursor-pointer">
                                <input type={'checkbox'} onChange={(e: any) => { setFloatingTime(e.target.checked) }} disabled checked />
                                <span className=" text-[10px] mr-2">زمان ورود و خروج شناور باشد</span>
                            </label>
                            <div className=" w-full sm:w-[50%] h-[50px] pl-1 sm:pl-2">
                                <CInputText name="duration" title="میزان کارکرد (دقیقه)" type="number" required={true} />
                            </div>
                        </div>
                    </div>
                }

                {(flexible == -1 || flexible == 0) &&
                    <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                        <div className=" w-full md:w-2/12 h-[50px] flex items-center md:mb-0 mb-1">
                            <svg x="0px" y="0px" viewBox={'0 0 24 24'} className={`  h-5 'fill-dayan-gray-100' `}>
                                <use xlinkHref="/assetes/svg/exit.svg#exit" />
                            </svg>
                            <span className="text-[11px] mr-3"> ساعت شروع </span>
                        </div>
                        <div className=" w-full md:w-10/12  flex flex-col sm:flex-row items-center">
                            <div className=" w-full sm:w-[50%] h-[50px] flex  items-center sm:mt-0 mt-8 pl-0 sm:pl-2 relative">
                                <span className="text-[11px] top-[-35px] left-0 right-0 mx-auto text-center absolute">ساعت ورود</span>
                                <div className=" w-[50%] h-full pl-1">
                                    <CSelect name="start_hours" placeholder={'ساعت'} title="ساعت" border={true} required={true}>
                                        {['00','01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'].map((item: any, index: number) =>
                                            <option key={index} value={item}>{item}</option>
                                        )}
                                    </CSelect>
                                </div>
                                <div className=" w-[50%] h-full pr-1">
                                    <CSelect name="start_min" placeholder={'دقیقه'} title="دقیقه" border={true} required={true}>
                                        {['00','01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'].map((item: any, index: number) =>
                                            <option key={index} value={item}>{item}</option>
                                        )}
                                    </CSelect>
                                </div>
                            </div>
                            <div className=" w-full sm:w-[50%] h-[50px] sm:mt-0 mt-5 pr-0 sm:pr-2">
                                <div className=" w-full  h-[50px] pl-1 sm:pl-2">
                                    <CInputText name="allowed_lateness_on_arrival" title=" زمان شناور ورود (دقیقه)" type="number" required={true} />
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {(flexible == -1 || flexible == 0) &&
                    <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                        <div className=" w-full md:w-2/12 h-[50px] flex items-center md:mb-0 mb-1">
                            <svg x="0px" y="0px" viewBox={'0 0 24 24'} className={`  h-5 'fill-dayan-gray-100' `}>
                                <use xlinkHref="/assetes/svg/exit.svg#exit" />
                            </svg>
                            <span className="text-[11px] mr-3">  ساعت اتمام </span>
                        </div>
                        <div className=" w-full md:w-10/12  flex flex-col sm:flex-row items-center">
                            <div className=" w-full sm:w-[50%] h-[50px] flex  items-center sm:mt-0 mt-8 pl-0 sm:pl-2 relative">
                                <span className="text-[11px] top-[-35px] left-0 right-0 mx-auto text-center absolute">ساعت خروج</span>
                                <div className=" w-[50%] h-full pl-1">
                                    <CSelect name="end_hours" placeholder={'ساعت'} title="ساعت" border={true} required={true}>
                                        {['00','01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'].map((item: any, index: number) =>
                                            <option key={index} value={item}>{item}</option>
                                        )}
                                    </CSelect>
                                </div>
                                <div className=" w-[50%] h-full pr-1">
                                    <CSelect name="end_min" placeholder={'دقیقه'} title="دقیقه" border={true} required={true}>
                                        {['00','01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'].map((item: any, index: number) =>
                                            <option key={index} value={item}>{item}</option>
                                        )}
                                    </CSelect>
                                </div>
                            </div>
                            <div className=" w-full sm:w-[50%] h-[50px] sm:mt-0 mt-5 pr-0 sm:pr-2">
                                <div className=" w-full  h-[50px] pl-1 sm:pl-2">
                                    <CInputText name="allowed_rushing_on_exit" title=" زمان شناور خروج (دقیقه)" type="number" required={true} />
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {(flexible == -1 || flexible == 0) &&
                    <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                        <div className=" w-full md:w-2/12 h-[50px] flex items-center md:mb-0 mb-1">
                            <svg x="0px" y="0px" viewBox={'0 0 470 470'} className={`  h-5 'fill-dayan-gray-100' `}>
                                <use xlinkHref="/assetes/svg/clock2.svg#clock2" />
                            </svg>
                            <span className="text-[11px] mr-3"> بازه زمانی اضافه‌کاری </span>
                        </div>
                        <div className=" w-full md:w-10/12  flex sm:flex-nowrap flex-wrap items-center">
                            <div className=" w-full sm:w-[50%] h-[50px] mt-[10px] sm:mt-0 pl-1 sm:pl-2">
                                <CInputText name="allowed_rushing_on_arrival" title="بازه اضافه‌کاری مجاز قبل از شیفت (دقیقه) " type="number" required={true} />
                            </div>
                            <div className=" w-full sm:w-[50%] h-[50px] mt-[20px] sm:mt-0 pl-1 sm:pl-2">
                                <CInputText name="allowed_lateness_on_exit" title="بازه اضافه‌کاری مجاز بعد از شیفت (دقیقه) " type="number" required={true} />
                            </div>
                        </div>
                    </div>
                }


                <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full md:w-2/12 h-[50px] flex items-center md:mb-0 mb-1">
                        <svg x="0px" y="0px" viewBox={'0 0 511.979 511.979'} className={`  h-5 'fill-dayan-gray-100' `}>
                            <use xlinkHref="/assetes/svg/repeat.svg#repeat" />
                        </svg>
                        <span className="text-[11px] mr-3">  الگوی تکرار  </span>
                    </div>
                    <div className=" w-full md:w-10/12  flex flex-col">
                        <div className=" w-full flex sm:flex-nowrap flex-wrap items-center">
                            <div className="w-[25%] md:w-[14.2%] px-1 mb-1">
                                <label className="w-full h-[70px] bg-gray-200 rounded flex flex-col justify-center items-center cursor-pointer">
                                    <input name="sat" type={'checkbox'} />
                                    <span className="text-[11px] mt-3">شنبه</span>
                                </label>
                            </div>
                            <div className="w-[25%] md:w-[14.2%] px-1 mb-1">
                                <label className="w-full h-[70px] bg-gray-200 rounded flex flex-col justify-center items-center cursor-pointer">
                                    <input name="sun" type={'checkbox'} />
                                    <span className="text-[11px] mt-3">یکشنبه</span>
                                </label>
                            </div>
                            <div className="w-[25%] md:w-[14.2%] px-1 mb-1">
                                <label className="w-full h-[70px] bg-gray-200 rounded flex flex-col justify-center items-center cursor-pointer">
                                    <input name="mon" type={'checkbox'} />
                                    <span className="text-[11px] mt-3">دوشنبه</span>
                                </label>
                            </div>
                            <div className="w-[25%] md:w-[14.2%] px-1 mb-1">
                                <label className="w-full h-[70px] bg-gray-200 rounded flex flex-col justify-center items-center cursor-pointer">
                                    <input name="tue" type={'checkbox'} />
                                    <span className="text-[11px] mt-3">سه شنبه</span>
                                </label>
                            </div>
                            <div className="w-[25%] md:w-[14.2%] px-1 mb-1">
                                <label className="w-full h-[70px] bg-gray-200 rounded flex flex-col justify-center items-center cursor-pointer">
                                    <input name="wed" type={'checkbox'} />
                                    <span className="text-[11px] mt-3">چهارشنبه</span>
                                </label>
                            </div>
                            <div className="w-[25%] md:w-[14.2%] px-1 mb-1">
                                <label className="w-full h-[70px] bg-gray-200 rounded flex flex-col justify-center items-center cursor-pointer">
                                    <input name="thu" type={'checkbox'} />
                                    <span className="text-[11px] mt-3">پنجشنبه</span>
                                </label>
                            </div>
                            <div className="w-[25%] md:w-[14.2%] px-1 mb-1">
                                <label className="w-full h-[70px] bg-gray-200 rounded flex flex-col justify-center items-center cursor-pointer">
                                    <input name="fri" type={'checkbox'} />
                                    <span className="text-[11px] mt-3">جمعه</span>
                                </label>
                            </div>
                        </div>
                        <label className="mt-5 flex items-center cursor-pointer">
                            <input name='except_holidays' type={'checkbox'} defaultChecked={singleData?.except_holidays == 1 ? true : false} />
                            <span className="text-[11px] mr-3">کل روزها به جزء تعطیلات تعریف شده </span>
                        </label>
                    </div>
                </div>

                <div className=" w-full mt-[40px] flex items-center">
                    {CtxLoad.displayLoadingBtn ?
                        <button type="button" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow cursor-not-allowed relative flex justify-center items-center"><BtnLoader /></button>
                        :
                        <button type="submit" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow">اعمال</button>
                    }
                    <Link to='/p/settings/schedules'>
                        <button type="button" className="w-[100px] h-[40px] bg-[#a4a4a4] text-dayan-gray-200 rounded-[5px] mr-3 text-sm shadow">بازگشت</button>
                    </Link>
                </div>

            </form>

        </div>
    )
}